import type { RootState } from 'state';
import type { RoutesFiltersState } from '../slice';

function getAirportsTo(state: RootState): RoutesFiltersState['airportsTo'] {
  const { airportsTo } = state.flightRoutes.filtersValues;
  return airportsTo;
}

export default getAirportsTo;
